module.exports = __webpack_public_path__ + "img/wood boards dark.deb4fba5.jpg";